const INITIAL_STATE = {
  permicaoList: [],
  permicao: null,
  permissaoFiltro: ''
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'PERMICAOLIST_FETCH':
      return { ...state, permicaoList: action.payload }
    case 'PERMICAO_SET':
      return { ...state, permicao: action.payload }
    case 'PERMISSAO_CHANGE_INPUT': {
      const permissaoCopy = action.payload
      return { ...state, permissaoFiltro: permissaoCopy }
    }
    case 'PERMISSAO_LIMPAR_INPUT': {
      const permissaoCopy = ''
      return { ...state, permissaoFiltro: permissaoCopy }
    }
    default:
      return state
  }
}